import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { LayoutsTable, NewbuildingLayoutsContext } from '@cian/frontend-newbuilding-layouts-widget';
import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { getOfferCustomUrl } from 'shared/selectors/analytics/getOfferCustomUrl';
import { selectOfferId } from 'shared/selectors/offerData/offer/selectOfferId';

import { BookedOfferLayoutsWrapper } from '../../components/BookedOfferLayoutsWrapper';
import { selectBookedOfferLayouts } from '../../selectors/newbuildingBookedOfferLayouts';
import { useApplicationContext } from '../ApplicationContext';
import { trackFavoriteClick, trackLayoutClick, trackLayoutsShown } from './tracking';

export const BookedOfferLayoutsContainer: React.FC = () => {
  const layouts = useSelector(selectBookedOfferLayouts);
  const gaLabel = useSelector(getOfferCustomUrl);
  const offerId = useSelector(selectOfferId);

  const context = useApplicationContext();

  const handleFavoriteAdd = React.useCallback(
    (offerId: number) => {
      trackFavoriteClick({ gaLabel, id: offerId });
    },
    [gaLabel],
  );

  const handleOfferLinkClick = React.useCallback(
    (layoutOfferId: number) => {
      trackLayoutClick({
        layoutOfferId,
        offerId,
        position: layouts.findIndex(layout => layout.offerId === layoutOfferId) + 1,
      });
    },
    [layouts, offerId],
  );

  const handleShowLayouts = React.useCallback(() => {
    trackLayoutsShown(
      1,
      layouts.slice(0, 5).map(layout => layout.offerId),
    );
  }, [layouts]);

  if (!layouts || layouts.length === 0) {
    return null;
  }

  const header = layouts.length === 1 ? 'Такая же квартира на другом этаже' : 'Такие же квартиры на других этажах';

  return (
    <ActionAfterViewObserver callback={handleShowLayouts} triggerOnce>
      <BookedOfferLayoutsWrapper>
        <UIHeading1 as="h2">{header}</UIHeading1>
        <NewbuildingLayoutsContext.Provider value={context}>
          <LayoutsTable
            initialOffers={layouts}
            onOfferLinkClick={handleOfferLinkClick}
            onFavoriteAdd={handleFavoriteAdd}
            onPageChange={trackLayoutsShown}
          />
        </NewbuildingLayoutsContext.Provider>
      </BookedOfferLayoutsWrapper>
    </ActionAfterViewObserver>
  );
};
